import React, { Suspense } from 'react';

import type { StepperStore } from '@tasama/ui';
import type { CompanyType } from '@tasama/ui';

const BusinessAdvisorContainer = React.lazy(() =>
  import('@tasama/business-advisor').then((m) => ({
    default: m.BusinessAdvisorContainer,
  }))
);

interface BusinessAdvisorFeatureProps {
  stepperStore?: StepperStore;
  companyType?: CompanyType;
}

export function BusinessAdvisorFeature({
  stepperStore,
  companyType,
}: BusinessAdvisorFeatureProps) {
  return (
    <Suspense fallback={null}>
      <BusinessAdvisorContainer
        {...(stepperStore && { stepperStore })}
        {...(companyType && { companyType })}
      />
    </Suspense>
  );
}

export default BusinessAdvisorFeature;
